import { LandingCtas } from "./LandingCtas";

export const LandingCustomers = ({ data }) => {
  return (
    <section className="section-layout">
      {data?.fields?.headline && <h3>{data?.fields?.headline}</h3>}
      {data?.fields?.subheadline && <p>{data?.fields?.subheadline}</p>}
      {data?.fields?.logos && (
        <div className="LandingCustomers">
          {data?.fields?.logos.map(logo => (
            <img src={logo.image} alt={logo.image_alt} key={logo} loading="lazy" />
          ))}
        </div>
      )}
      {data?.fields?.ctas && <LandingCtas ctas={data?.fields?.ctas} />}
    </section>
  );
};
